import axios from "@/components/api/axios";

const list = request => {
    return axios.post(
        '/users/list',
        request).then(response => response.data)
}

const get = request => {
    return axios.post(
        '/users/get',
        request).then(response => response.data)
}

const add = request => {
    return axios.post(
        '/users',
        request).then(response => response.data)
}

const upd = request => {
    return axios.put(
        '/users',
        request).then(response => response.data)
}

export default {
    get,
    list,
    add,
    upd
}